/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpuResVo
 */
export interface SpuResVo {
    /**
     * SPU主键ID
     * @type {number}
     * @memberof SpuResVo
     */
    id?: number;
    /**
     * SPU编码
     * @type {string}
     * @memberof SpuResVo
     */
    code?: string;
    /**
     * SPU名称
     * @type {string}
     * @memberof SpuResVo
     */
    name?: string;
    /**
     * 产地标签：Y-是，N-否
     * @type {string}
     * @memberof SpuResVo
     */
    originLabel?: string;
    /**
     * 是否年满14岁：Y-是，N-否
     * @type {string}
     * @memberof SpuResVo
     */
    underFourteenYearsOld?: string;
    /**
     * 有效期标识：Y-有，N-无
     * @type {string}
     * @memberof SpuResVo
     */
    validPeriod?: string;
    /**
     * 启用状态：0-下架，1-上架
     * @type {number}
     * @memberof SpuResVo
     */
    enable?: number;
    /**
     * 删除状态：0-未删除，1-已删除
     * @type {number}
     * @memberof SpuResVo
     */
    deleteStatus?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof SpuResVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof SpuResVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the SpuResVo interface.
 */
export function instanceOfSpuResVo(value: object): value is SpuResVo {
    return true;
}

export function SpuResVoFromJSON(json: any): SpuResVo {
    return SpuResVoFromJSONTyped(json, false);
}

export function SpuResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpuResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'originLabel': json['originLabel'] == null ? undefined : json['originLabel'],
        'underFourteenYearsOld': json['underFourteenYearsOld'] == null ? undefined : json['underFourteenYearsOld'],
        'validPeriod': json['validPeriod'] == null ? undefined : json['validPeriod'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function SpuResVoToJSON(json: any): SpuResVo {
    return SpuResVoToJSONTyped(json, false);
}

export function SpuResVoToJSONTyped(value?: SpuResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'originLabel': value['originLabel'],
        'underFourteenYearsOld': value['underFourteenYearsOld'],
        'validPeriod': value['validPeriod'],
        'enable': value['enable'],
        'deleteStatus': value['deleteStatus'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

